import { checkoutUserErrorFragment } from './fragmentGeneral.gql';
import checkoutFragment from './fragmentCheckout.gql';

const checkoutLineItemsAdd = ({ country }) => (
	`mutation ($checkoutId: ID!, $lineItems: [CheckoutLineItemInput!]!) @inContext(country: ${country}) {
		checkoutLineItemsAdd(checkoutId: $checkoutId, lineItems: $lineItems) {
			checkoutUserErrors ${checkoutUserErrorFragment}
			checkout ${checkoutFragment}
		}
	}`
);

export default checkoutLineItemsAdd;
